const data = require(`./data_${process.env.REACT_APP_BUILD_UID}/metaData.json`)
const metaData = {...data}

export default metaData